import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { faqs } from "../../data/faqs";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-4 py-16 sm:py-20" data-id="element-164" data-mp="122vdgi6sqxqj">
      <div className="mx-auto max-w-3xl" data-id="element-165" data-mp="1prxsrjdykehv">
        <SectionHeading title="Frequently Asked Questions" data-id="element-166" data-mp="1pszfil4c6pff" />
        <div className="mt-10 space-y-3" data-id="element-167" data-mp="1urk9w3wwqevy">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-[0_4px_16px_rgba(14,37,87,0.05)]" data-id="element-168" data-mp="1g0bm80ckf3lg" data-mpi={i}>
                <h3 data-id="element-169" data-mp="28r208npuq07f">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 p-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand" data-id="element-170" data-mp="28qjun0hau9mu">
                    <span className="text-[17px] font-black leading-snug text-navy" data-id="element-171" data-mp="2ygjwyc1tgqjn">
                      {i + 1}. {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-172" data-mp="2tn8q4ax089rq" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-173" data-mp="3hee6qsarr633">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-174" data-mp="3cgupdjiryd6x">
                      <div className="space-y-3 px-5 pb-5" data-id="element-175" data-mp="27sa9tvyt6ebq">
                        {faq.a.map(p => <p key={p} className="text-[15px] font-semibold leading-relaxed text-ink/80" data-id="element-176" data-mp="2gqm1m1bevi5r">
                            {p}
                          </p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <div className="mt-10" data-id="element-177" data-mp="2uou1oi3quzl5">
          <CtaButton label="I’m ready — get my Blueprint™" sub="Secure Checkout · One-Time Payment of $27" data-id="element-178" data-mp="2zh3pnslatpks" />
        </div>
      </div>
    </section>;
}